export default "__VITE_PUBLIC_ASSET__a0a5a414__"